<template>
  <div class="attr-panel">
    <dl v-if="attr" class="attr-dl mb-0">
      <dt class="attr-dt">{{ t('attractionEditingTitleLabel') }}</dt>
      <dd class="attr-dd">{{ display(attr.title) }}</dd>
      <dt class="attr-dt">{{ t('attractionEditingAddressLabel') }}</dt>
      <dd class="attr-dd">{{ display(attr.address) }}</dd>
      <dt class="attr-dt">{{ t('attractionEditingImageLabel') }}</dt>
      <dd class="attr-dd attr-dd-image">
        <img
          v-if="attr.image"
          :src="attr.image"
          :alt="attr.title || 'Attraction'"
          class="compare-thumb"
        >
        <span v-else>{{ display(attr.image) }}</span>
      </dd>
      <dt class="attr-dt">{{ t('attractionEditingDescriptionLabel') }}</dt>
      <dd class="attr-dd attr-dd-multiline">{{ display(attr.text) }}</dd>
      <dt class="attr-dt">{{ t('website') }}</dt>
      <dd class="attr-dd">
        <a v-if="attr.link" :href="attr.link" target="_blank" rel="noopener noreferrer">{{ attr.link }}</a>
        <span v-else>{{ display(attr.link) }}</span>
      </dd>
      <dt class="attr-dt">{{ t('voucher') }}</dt>
      <dd class="attr-dd">
        <template v-if="attr.voucherUrls && attr.voucherUrls.length">
          <a
            v-for="(vUrl, vIdx) in attr.voucherUrls"
            :key="vIdx"
            :href="vUrl"
            target="_blank"
            rel="noopener noreferrer"
            style="display: block;"
          >{{ attr.voucherUrls.length === 1 ? t('voucher') : t('voucher') + ' ' + (vIdx + 1) }}</a>
        </template>
        <span v-else>-</span>
      </dd>
    </dl>
    <p v-else class="text-muted mb-0">{{ t('masterAccommodationCompareEmpty') }}</p>
  </div>
</template>

<script>
import { translationMixin } from '@/mixins/translationMixin';

export default {
  name: 'AttractionComparePanel',
  mixins: [translationMixin],
  props: {
    attr: {
      type: Object,
      default: null,
    },
  },
  methods: {
    display(val) {
      if (val === null || val === undefined || val === '') {
        return this.t('masterAccommodationCompareEmpty');
      }
      return String(val);
    },
  },
};
</script>

<style scoped>
.attr-dl {
  text-align: inherit;
}
.attr-dt {
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: #666;
  margin-bottom: 2px;
  margin-top: 10px;
}
.attr-dt:first-child {
  margin-top: 0;
}
.attr-dd {
  font-size: 15px;
  color: #1e1e1e;
  margin-bottom: 0;
  word-break: break-word;
}
.attr-dd-multiline {
  white-space: pre-wrap;
}
.attr-dd-image {
  margin-top: 4px;
}
.compare-thumb {
  display: block;
  max-width: 100%;
  max-height: 160px;
  width: auto;
  height: auto;
  object-fit: contain;
  border-radius: 8px;
  border: 1px solid #e8e8e8;
}
</style>
